module.exports = __webpack_public_path__ + "img/picture_kmskcspvip02.e43336af.png";